/**
 * wordsearch.js
 *
 * Generate a wordsearch puzzle
 *
 * Author: Dave Eddy <dave@daveeddy.com>
 * Date: 2/24/13
 * @preserve
 */

(function() {
  /**
   * wordsearch
   *
   * generate a wordsearch puzzle
   */
  function wordsearch(words, width, height, country = "it", opts) {
    // var LETTERS = "abcdefghijklmnopqrstuvwxyz"; // letters used for filler
    // var WORD_RE = /^[a-z]+$/; // what a valid word looks like
    var LETTERS = "ABCDEFZHIKLMNOPQRSTVX";
    var WORD_RE = /^[A-Z]+$/; // what a valid word looks like
    var MAX_ATTEMPTS = 20; // maximum amount of times to place a word

    if (country.includes("ru")) {
      // LETTERS = "абвгдеёжзийклмнопрстуфхцчшщъыьэюя";
      // WORD_RE = /[\wа-я]+/gi;
      LETTERS = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ";
      WORD_RE = /[\A-Я]+/gi;
    }

    if (!words || !words.length) return false;
    width = +width || 20;
    height = +height || 20;
    opts = opts || {};
    opts.backwards = opts.hasOwnProperty("backwards") ? opts.backwards : 0.5;
    opts.letters = opts.letters || LETTERS;
    // filter out any non-words
    words = words.filter(function(a) {
      return a.match(WORD_RE);
    });

    // sort the words by length (biggest first)
    words.sort(function(a, b) {
      return a.length < b.length ? -1 : 1;
    });

    // populate the grid with empty arrays
    var grid = new Array(height);
    for (var i = 0; i < grid.length; i++) grid[i] = new Array(width);

    var unplaced = [];
    let keywords = [];
    let backwards = false;

    // loop the words
    var colorNo = 0;
    for (var i = 0; i < words.length; i++) {
      var word = (originalWord = words[i]);

      // NOTE: Option disabled in order to get the coordinates of starting point.
      // reverse the word if needed
      // if (Math.random() < opts.backwards) {
      if (false) {
        word = word
          .split("")
          .reverse()
          .join("");
        backwards = true;
      }

      // pick a random spot
      // try to place the word in the grid
      var attempts = 0;
      while (attempts < MAX_ATTEMPTS) {
        // determine the direction (up-right, right, down-right, down)
        var direction = Math.floor(Math.random() * 4);
        var info = directionInfo(word, direction, width, height);

        // word is too long, bail out
        if (
          info.maxX < 0 ||
          info.maxY < 0 ||
          info.maxY < info.minY ||
          info.maxX < info.minx
        ) {
          unplaced.push(originalWord);
          break;
        }

        // random starting point
        var x = (ox = Math.round(
          Math.random() * (info.maxX - info.minx) + info.minx
        ));
        var y = (oy = Math.round(
          Math.random() * (info.maxY - info.minY) + info.minY
        ));

        // check to make sure there are no collisions
        var placeable = true;
        var count = 0;
        for (var l = 0; l < word.length; l++) {
          var charInGrid = grid[y][x];

          if (charInGrid) {
            // check if there is a character in the grid
            if (charInGrid !== word.charAt(l)) {
              // not the same latter, try again
              placeable = false; // :(
              break;
            } else {
              // same letter! count it
              count++;
            }
          }
          // keep trying!
          y += info.dy;
          x += info.dx;
        }
        if (!placeable || count >= word.length) {
          attempts++;
          continue;
        }

        // the word was placeable if we make it here!
        // reset x and y and place it
        x = ox;
        y = oy;
        keywords.push({
          word: word,
          startingX: x,
          startingY: y,
          backwards: backwards,
        });
        for (var l = 0; l < word.length; l++) {
          grid[y][x] = word.charAt(l);
          if (opts.color) {
            grid[y][x] = `[${colorNo + 41}m${grid[y][x]}[0m`;
          }
          y += info.dy;
          x += info.dx;
        }
        break;
      } // end placement while loop

      if (attempts >= 20) unplaced.push(originalWord);
      colorNo = (colorNo + 1) % 6;
    } // end word loop

    // the solved grid... XXX I hate this
    var solved = JSON.parse(JSON.stringify(grid));

    // put in filler characters
    for (var i = 0; i < grid.length; i++)
      for (var j = 0; j < grid[i].length; j++)
        if (!grid[i][j]) {
          solved[i][j] = " ";
          grid[i][j] = opts.letters.charAt(
            Math.floor(Math.random() * opts.letters.length)
          );
        }

    // give the user some stuff
    return {
      grid: grid,
      solved: solved,
      unplaced: unplaced,
      keywords: keywords,
    };
  }

  /**
   * given an integer that represents a direction,
   * return an object with boundary information
   * and velocity
   */
  function directionInfo(word, direction, width, height) {
    // determine the bounds
    var minx = 0,
      minY = 0;
    var maxX = width - 1;
    var maxY = height - 1;
    var dx = 0,
      dy = 0;
    switch (direction) {
      case 0: // up-right
        // maxY = height - 1;
        // minY = word.length - 1;
        // dy = -1;
        // maxX = width - word.length;
        // minx = 0;
        // dx = 1;
        maxX = width - word.length;
        minx = 0;
        dx = 1;
        break;
      case 1: // right
        maxX = width - word.length;
        minx = 0;
        dx = 1;
        break;
      case 2: // down-right
        // minY = 0;
        // maxY = height - word.length;
        // dy = 1;
        // maxX = width - word.length;
        // minx = 0;
        // dx = 1;
        minY = 0;
        maxY = height - word.length;
        dy = 1;
        break;
      case 3: // down
        minY = 0;
        maxY = height - word.length;
        dy = 1;
        break;
      default:
        /* NotReached */
        break;
    }
    return {
      maxX: maxX,
      maxY: maxY,
      minx: minx,
      minY: minY,
      dx: dx,
      dy: dy,
    };
  }

  // export the function
  if (typeof exports === "undefined") window.wordsearch = wordsearch;
  else module.exports = wordsearch;
})();
